import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import localization from "../../../config/localization";
import { Button } from "../../../components/ui";

interface GeneralPaymentHelpProps {
  open: boolean;
  onToggle: (value: boolean) => void;
  amount: string;
}

export const GeneralPaymentHelp = ({
  open,
  onToggle,
  amount,
}: GeneralPaymentHelpProps) => {
  return (
    <div className="relative mt-3">
      <div
        className={`
          absolute bottom-full left-0 right-0
          bg-black
          transition-all duration-300 ease-in-out
          overflow-hidden
          z-20
          ${open ? "max-h-80 opacity-100 mb-2" : "max-h-0 opacity-0 mb-0"}
        `}
      >
        <Button
          type="button"
          onClick={() => onToggle(false)}
          className="w-full flex items-center justify-between
                      text-[#A9A9A9] text-base font-semibold my-4"
        >
          <span>{localization.general_payment_help || "General Payment Help"}</span>
          <FontAwesomeIcon
            icon={faChevronDown}
            className="h-4 w-4 rotate-180"
          />
        </Button>

        <div className="text-sm font-semibold text-[#E3E3E3] space-y-5">
          <p>01. {localization.general_payment_help_step1?.replace("{amount}", amount)}</p>
          <p>02. {localization.general_payment_help_step2}</p>
          <p>03. {localization.general_payment_help_step3}</p>
          <p>04. {localization.general_payment_help_step4}</p>
        </div>
      </div>

      {!open && (
        <Button
          type="button"
          onClick={() => onToggle(true)}
          className="w-full flex items-center justify-between
                     text-[#A9A9A9] text-md font-semibold relative z-30"
        >
          <span>{localization.general_payment_help}</span>
          <FontAwesomeIcon icon={faChevronDown} className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};
